class FooterNav extends HTMLElement {
    constructor() {
        super();

        this.navList = this.querySelector('.c-footer__nav-list');
        this.arrow = this.querySelector('.nav-links-menu-arrow');
        // this.navHeading = this.querySelector('.c-footer__nav-title').addEventListener('click', () => {
        //     this.navList.classList.toggle('mobile-hidden');
        //     this.arrow.classList.toggle('rotate');
        // });
        this.navHeading = this.querySelector('.c-footer__nav-title');

        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        this.navHeading.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
        this.navHeading.removeEventListener('click', this.handleClick);
    }

    handleClick() {
        this.navList.classList.toggle('mobile-hidden');
        this.arrow.classList.toggle('rotate');
    }
}

customElements.define('footer-nav', FooterNav);
